import React from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import {
  openModalTourDownload,
  TourDownloadBasketData,
  TourDownloadCoord,
} from 'actions/TourDownload/tourDownloadGps.action';

import withTranslations from 'app/components/HOGs/withTranslations';

import { addToDownload } from 'app/components/Utility/utility';

import { Button } from 'antd';

const MainButtons = (props) => {
  const { tr, currentTourId } = props;

  const dispatch = useDispatch();

  const data = useSelector((store) => store.tourFullData.data);

  const activeMultiPart = useSelector(
    (store) => store.tourFullData.activeMultiPart
  );
  const isEditMode = useSelector((store) => store.tourFullData.isEditMode);

  const activeTourTab = useSelector(
    (store) => store.tourFullData.activeTourTab
  );

  const downloadData = useSelector((store) => store.tourDownload.data);

  const openModalTourDownloadHandler = (data) => {
    dispatch(openModalTourDownload(data));
  };

  const tourDownloadBasketData = (data) => {
    dispatch(TourDownloadBasketData(data));
  };
  const tourDownloadCoord = (data) => {
    dispatch(TourDownloadCoord(data));
  };

  const clickBtnAddToDownload = (e) => {
    if (data.length !== 0) {
      const tourData = data && data.multiDay === true ? data : activeMultiPart;
      const id = parseInt(tourData.id);
      tourData.id = id;
      addToDownload(
        e,
        downloadData,
        tourData,
        openModalTourDownloadHandler,
        tourDownloadBasketData,
        tourDownloadCoord,
        { tourAdded: tr['Already added to download'] },
        'tour'
      );
    } else {
      console.log('loading');
    }
  };

  return isEditMode ? null : (
    <div className="mainButton">
      <Link to={`/createtour?copy=${currentTourId}&part=${activeTourTab}`}>
        <Button className="btn plan">
          <span>{tr['Plan in Create Tour']}</span>
        </Button>
      </Link>
      <Button
        type="primary"
        className="btn download"
        onClick={(e) => clickBtnAddToDownload(e)}
      >
        <span>{tr['Add to download']}</span>
      </Button>
    </div>
  );
};

export default withTranslations(MainButtons);
